import { useTranslation } from 'react-i18next';
import { Card, CardContent } from 'components/ui/card';
import { TokenUsageMetrics } from 'features/usage/services/usage-service';
import { formatNumber, getAverage } from 'features/usage/utils/usage-format';
import { UsageSectionLabel } from './usage-section-label';

export function UsageTokenBreakdown({
  totals,
  completionRatio,
  promptShare,
  completionShare,
}: {
  totals: TokenUsageMetrics;
  completionRatio: string;
  promptShare: number;
  completionShare: number;
}) {
  const { t } = useTranslation();

  return (
    <div className="space-y-4">
      <UsageSectionLabel>{t('TOKEN_BREAKDOWN')}</UsageSectionLabel>
      <Card className="border-border/70 shadow-none">
        <CardContent className="p-5 md:p-6">
          <div className="overflow-hidden rounded-xl border border-border">
            <div className="grid gap-px bg-border md:grid-cols-2">
              <div className="bg-primary-25 p-5">
                <div className="mb-3 flex items-center gap-2 text-xs font-medium text-white">
                  <span className="h-2 w-2 rounded-full bg-primary" />
                  {t('INPUT')}
                </div>
                <div className="font-mono text-3xl font-medium tracking-tight text-white">
                  {formatNumber(totals.input_tokens)}
                </div>
                <div className="mt-2 text-xs text-muted-foreground">
                  {t('AVG_PER_REQ_SLASH', {
                    avg: getAverage(totals.input_tokens, totals.turn_count),
                  })}
                </div>
                <div className="mt-3 font-mono text-lg text-white">{promptShare.toFixed(1)}%</div>
              </div>
              <div className="bg-secondary-50 p-5">
                <div className="mb-3 flex items-center gap-2 text-xs font-medium text-success-green">
                  <span className="h-2 w-2 rounded-full bg-success-green" />
                  {t('OUTPUT')}
                </div>
                <div className="font-mono text-3xl font-medium tracking-tight text-success-green">
                  {formatNumber(totals.output_tokens)}
                </div>
                <div className="mt-2 text-xs text-muted-foreground">
                  {t('AVG_PER_REQ_SLASH', {
                    avg: getAverage(totals.output_tokens, totals.turn_count),
                  })}
                </div>
                <div className="mt-3 font-mono text-lg text-success-green">
                  {completionShare.toFixed(1)}%
                </div>
              </div>
            </div>
          </div>

          <div className="mt-5 flex items-center justify-between border-t border-border py-3 text-sm">
            <span className="text-muted-foreground">{t('OUTPUT_INPUT_RATIO')}</span>
            <span className="font-mono text-foreground">{completionRatio}</span>
          </div>
          <div className="border-t border-border pt-3 text-sm text-muted-foreground">
            {t('SPLIT_NOTE')}
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
